module.exports = __WEBPACK_EXTERNAL_MODULE_26__;


//////////////////
// WEBPACK FOOTER
// external "lwr-client"
// module id = 26
// module chunks = 4